import { useMemo } from 'react'

import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import {
  GlobalAlertService,
  ListPlanAutoSubmitNoticesRequestSchema,
} from '@ebalance/proto/bffuser/v1/global_alert_service_pb'

import {
  SIDE_MENU_DOT_QUERY_OPTIONS,
  freshSideMenuDotData,
} from '~/hooks/sideMenuDotQuery'
import {
  EMPTY_PLAN_AUTO_SUBMIT_NOTICES,
  type PlanAutoSubmitNotices,
} from '~/models/planAutoSubmitNoticeRows'

/**
 * 自動で提出・出し直しできなかった計画の知らせ (AC-SC-042 / AC-PPL-035)。
 * サイドメニューのドット用に layout の `SideMenuDotsProvider` が 1 か所で呼ぶ (observer を
 * 増やすと `refetchInterval` が observer ごとに走り、30 秒に複数回取得する)。計画一覧の
 * 警告バナーは `useLayoutPlanAutoSubmitNotices` でその結果を読む。組織は BFF が認証セッション
 * から決め、flag (`ebalance-workflow-automation`) が OFF の組織には backend が空を返す。
 *
 * 取得方針 (30 秒の再取得・失敗時は直前の data を捨てる等) は `sideMenuDotQuery` が持つ。
 * 取得中・取得失敗・オフラインで保留の間は空。
 */
export function usePlanAutoSubmitNotices(): PlanAutoSubmitNotices {
  const query = useQuery(
    GlobalAlertService.method.listPlanAutoSubmitNotices,
    create(ListPlanAutoSubmitNoticesRequestSchema, {}),
    SIDE_MENU_DOT_QUERY_OPTIONS,
  )
  const data = freshSideMenuDotData(query)
  // 再描画ごとに新しい object を返すと、Provider の context 値が毎回変わって購読側が描き直される
  return useMemo(
    () =>
      data === undefined
        ? EMPTY_PLAN_AUTO_SUBMIT_NOTICES
        : {
            unsubmitted: data.unsubmittedPlans,
            missedDeadline: data.missedDeadlinePlans,
          },
    [data],
  )
}
